function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg230Montenegro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.006,
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.261,
    y: 22.259,
    style: {
      fill: "#A2001D"
    },
    width: 467.478,
    height: 467.478
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "194.164,182.931 317.836,182.931 317.836,133.462 293.101,145.829 256,108.728    218.899,145.829 194.164,133.462  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M367.304,257.133h-61.813c2.424-4.193,3.833-9.046,3.833-14.237c0-15.763-12.779-28.54-28.54-28.54   c-10.89,0-20.348,6.102-25.16,15.068c-4.812-8.968-14.27-15.068-25.16-15.068c-15.761,0-28.54,12.777-28.54,28.54   c0,5.191,1.41,10.044,3.833,14.237h-61.063c0,18.914,16.474,34.247,35.388,34.247h-1.14c0,15.515,10.319,28.613,24.467,32.824   l-27.797,27.797l26.234,26.234l37.213-37.215c1.458,0.533,2.966,0.962,4.523,1.253l-22.487,50.773   c10.777,4.381,22.552,6.814,34.902,6.814c12.349,0,24.125-2.433,34.902-6.814l-22.487-50.773c1.558-0.293,3.065-0.72,4.522-1.253   l37.214,37.215l26.234-26.234l-27.797-27.797c14.148-4.21,24.468-17.308,24.468-32.824h-1.141   C350.828,291.381,367.304,276.048,367.304,257.133z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6DA544"
    },
    points: "256,275.684 215.807,294.235 215.807,331.336 256,356.07 296.193,331.336 296.193,294.235   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.808,
    y: 257.133,
    style: {
      fill: "#0052B4"
    },
    width: 80.384,
    height: 49.464
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg230Montenegro);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };